import { render, staticRenderFns } from "./salaryRule.vue?vue&type=template&id=6633093c&scoped=true&"
import script from "./salaryRule.vue?vue&type=script&lang=js&"
export * from "./salaryRule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6633093c",
  null
  
)

export default component.exports